export const getScoreType = (score: number): string => {
  if (score >= 0 && score <= 2) return 'very-low'
  if (score >= 3 && score <= 4) return 'low'
  if (score >= 5 && score <= 6) return 'medium'
  if (score >= 7 && score <= 8) return 'high'
  if (score >= 9 && score <= 10) return 'very-high'

  return ''
}
